import { render, staticRenderFns } from "./director-turmas-turmas.vue?vue&type=template&id=16024e54&"
import script from "./director-turmas-turmas.vue?vue&type=script&lang=js&"
export * from "./director-turmas-turmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports